module.exports = __webpack_public_path__ + "img/banner_hk.c185d3c3.jpg";